/*
  V2 · «¿Llega para mi fecha?» (pedido de Boris, 12/10/2026).

  El cliente dice para qué día lo necesita, qué producto y cómo lo recibe. La página le
  contesta en el momento si llega, y qué tiene que hacer para llegar.

  Reglas del taller (confirmadas por Boris):
  - Producción normal: 3 a 5 días hábiles desde que se aprueba el diseño. Algunos productos
    llevan 7 a 10 (los que tienen el metafield b2b.plazo).
  - Producción urgente (+10 %): de 1 a 3 días hábiles, según el producto.
  - Corte: lo que entra antes de las 14 h cuenta desde hoy; después, desde el día hábil siguiente.
  - El taller trabaja de lunes a viernes, salvo los feriados de Uruguay, que se calculan para cada año
    (Boris, 12/10: «basándote en los días feriados de cada año en Uruguay»).

  Los números viven en el JSON de snippets/tm-llega-fecha.liquid, no acá.
  Lo abre cualquier elemento con data-lf-abrir (opcional: data-lf-producto="handle").
*/
/* Núcleo sin DOM: toda la cuenta de fechas. Recibe los números del taller y el instante actual. */
function tmLlegaFechaNucleo(cfg) {
  var DIA = 86400000;

  /* Fechas: días de calendario de Montevideo, guardados a mediodía UTC para que no se corran. */
  function dia(anio, mes, numero) { return new Date(Date.UTC(anio, mes - 1, numero, 12)); }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function sumar(d, n) { return new Date(d.getTime() + n * DIA); }
  function ahora(instante) {
    var partes = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Montevideo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(instante || new Date()).forEach(function (p) { partes[p.type] = p.value; });
    return { hoy: dia(+partes.year, +partes.month, +partes.day), hora: +partes.hour };
  }
  /* Domingo de Pascua (calendario gregoriano, algoritmo de Meeus/Jones/Butcher). */
  function pascua(anio) {
    var a = anio % 19, b = Math.floor(anio / 100), c = anio % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31), numero = ((h + l - 7 * m + 114) % 31) + 1;
    return dia(anio, mes, numero);
  }
  /* Ley 16.805: 19/4, 18/5 y 12/10 se corren al lunes. Martes o miércoles, al lunes anterior;
     jueves o viernes, al lunes siguiente; sábado, domingo o lunes quedan donde caen. */
  function corrido(anio, mes, numero) {
    var d = dia(anio, mes, numero), semana = d.getUTCDay();
    if (semana === 2 || semana === 3) return sumar(d, 1 - semana);
    if (semana === 4 || semana === 5) return sumar(d, 8 - semana);
    return d;
  }
  /* Feriados de Uruguay de un año, calculados: no hay que cargarlos cada año. */
  var feriadosPorAnio = {};
  function feriadosUY(anio) {
    if (!feriadosPorAnio[anio]) {
      var p = pascua(anio);
      feriadosPorAnio[anio] = [
        dia(anio, 1, 1), dia(anio, 1, 6),            // Año Nuevo, Reyes
        sumar(p, -48), sumar(p, -47),               // Carnaval: lunes y martes
        sumar(p, -3), sumar(p, -2),                 // Semana de Turismo: jueves y viernes
        corrido(anio, 4, 19), dia(anio, 5, 1),      // Desembarco de los 33, Día de los Trabajadores
        corrido(anio, 5, 18), dia(anio, 6, 19),     // Batalla de Las Piedras, Natalicio de Artigas
        dia(anio, 7, 18), dia(anio, 8, 25),         // Jura de la Constitución, Independencia
        corrido(anio, 10, 12), dia(anio, 11, 2),    // Día de la Diversidad Cultural, Difuntos
        dia(anio, 12, 25)                           // Navidad
      ].map(iso);
    }
    return feriadosPorAnio[anio];
  }
  function esHabil(d) {
    var semana = d.getUTCDay();
    if (semana === 0 || semana === 6) return false;
    var texto = iso(d);
    if (feriadosUY(d.getUTCFullYear()).indexOf(texto) >= 0) return false;
    // cfg.cierres: días extra en que el taller no trabaja («2026-12-24» o «12-24» para todos los años).
    var cierres = cfg.cierres || [];
    return cierres.indexOf(texto) < 0 && cierres.indexOf(texto.slice(5)) < 0;
  }
  function sumarHabiles(d, n) { var r = d; while (n > 0) { r = sumar(r, 1); if (esHabil(r)) n--; } return r; }
  function restarHabiles(d, n) { var r = d; while (n > 0) { r = sumar(r, -1); if (esHabil(r)) n--; } return r; }
  function habilHasta(d) { var r = d; while (!esHabil(r)) r = sumar(r, -1); return r; }

  function largo(d) {
    return new Intl.DateTimeFormat('es-UY', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(d).replace(',', '');
  }
  function corto(d) {
    return new Intl.DateTimeFormat('es-UY', { timeZone: 'UTC', weekday: 'long', day: 'numeric' }).format(d).replace(',', '');
  }

  /* El día desde el que el taller empieza a contar. */
  function diaCero(instante) {
    var a = ahora(instante);
    var d = a.hoy;
    if (!esHabil(d) || a.hora >= cfg.corte) d = sumarHabiles(d, 1);
    return { dia: d, esHoy: iso(d) === iso(a.hoy), hoy: a.hoy };
  }

  function calcular(evento, prod, envio, instante) {
    var cero = diaCero(instante);
    var limite = habilHasta(evento); // último día hábil en que lo puede recibir
    var llegaMin = sumarHabiles(sumarHabiles(cero.dia, prod.min), envio);
    var llegaMax = sumarHabiles(sumarHabiles(cero.dia, prod.max), envio);
    var urgenteMin = sumarHabiles(sumarHabiles(cero.dia, cfg.urgenteMin), envio);
    var urgenteMax = sumarHabiles(sumarHabiles(cero.dia, cfg.urgenteMax), envio);
    var ultimoPedido = restarHabiles(restarHabiles(limite, envio), prod.max + 1);
    var estado;
    if (evento.getTime() <= cero.hoy.getTime()) estado = 'pasada';
    else if (llegaMax.getTime() < limite.getTime()) estado = 'ok';
    else if (llegaMin.getTime() <= limite.getTime()) estado = 'justo';
    else if (prod.urgente && urgenteMax.getTime() <= limite.getTime()) estado = 'urgente';
    else if (prod.urgente && urgenteMin.getTime() <= limite.getTime()) estado = 'confirmar';
    else estado = 'no';
    return { estado: estado, cero: cero, limite: limite, llegaMin: llegaMin, llegaMax: llegaMax, ultimoPedido: ultimoPedido,
      listoMin: sumarHabiles(cero.dia, prod.min), listoMax: sumarHabiles(cero.dia, prod.max) };
  }

  return { dia: dia, iso: iso, sumar: sumar, ahora: ahora, esHabil: esHabil, feriadosUY: feriadosUY, sumarHabiles: sumarHabiles,
    restarHabiles: restarHabiles, habilHasta: habilHasta, largo: largo, corto: corto, diaCero: diaCero, calcular: calcular };
}

if (typeof module !== 'undefined' && module.exports) module.exports = tmLlegaFechaNucleo;

(function () {
  if (typeof document === 'undefined') return;
  var dlg = document.getElementById('tm-llega-fecha');
  if (!dlg || dlg.dataset.lfListo) return;
  dlg.dataset.lfListo = '1';

  var cfg = JSON.parse(dlg.querySelector('[data-lf-config]').textContent);
  var n = tmLlegaFechaNucleo(cfg);
  var dia = n.dia, iso = n.iso, sumar = n.sumar, ahora = n.ahora, largo = n.largo, corto = n.corto, calcular = n.calcular;
  var campoFecha = dlg.querySelector('#lf-fecha');
  var campoProducto = dlg.querySelector('#lf-producto');
  var resultado = dlg.querySelector('[data-lf-resultado]');

  function productoElegido() {
    var op = campoProducto.options[campoProducto.selectedIndex];
    var datos = { handle: '', nombre: '', url: cfg.catalogo, min: cfg.min, max: cfg.max, urgente: true };
    if (!op || !op.value) return datos;
    datos.handle = op.value;
    datos.nombre = op.dataset.nombre || op.textContent.trim();
    datos.url = op.dataset.url || cfg.catalogo;
    var plazo = /(\d+)\s*a\s*(\d+)/.exec(op.dataset.plazo || '');
    if (plazo) { datos.min = +plazo[1]; datos.max = +plazo[2]; }
    // Los productos con plazo propio (7 a 10 días) no se prometen con urgencia: se consulta.
    datos.urgente = op.dataset.urgente !== '0' && !plazo;
    return datos;
  }


  function crear(etiqueta, clase, texto) {
    var el = document.createElement(etiqueta);
    if (clase) el.className = clase;
    if (texto) el.textContent = texto;
    return el;
  }

  function enlaceWhatsApp(prod, evento, entrega) {
    var que = prod.nombre ? prod.nombre : 'un trabajo';
    var mensaje = 'Hola! Necesito ' + que + ' para el ' + largo(evento) + '. ' + entrega.mensaje + ' ¿Llego a tiempo?';
    return 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(mensaje);
  }

  var ENTREGAS = {
    retiro: { dias: 0, listo: 'listo para retirar en Sayago', mensaje: 'Lo retiro en Sayago.' },
    // Con envío se informa cuándo está listo para salir. Los días de envío solo se usan como margen
    // para el veredicto: no están confirmados y no se le prometen al cliente.
    montevideo: { dias: cfg.envioMontevideo, listo: 'listo para enviar', mensaje: 'Va con envío en Montevideo.' },
    interior: { dias: cfg.envioInterior, listo: 'listo para despachar al interior', mensaje: 'Va con envío al interior.' }
  };

  function pintar() {
    resultado.textContent = '';
    if (!campoFecha.value) return;
    var partes = campoFecha.value.split('-');
    var evento = dia(+partes[0], +partes[1], +partes[2]);
    var prod = productoElegido();
    var marcado = dlg.querySelector('input[name="lf-entrega"]:checked');
    var entrega = ENTREGAS[marcado ? marcado.value : 'retiro'];
    var r = calcular(evento, prod, entrega.dias);
    var cuando = r.cero.esHoy ? 'hoy' : 'ahora';
    var nombre = prod.nombre ? prod.nombre : 'tu pedido';
    var rango = 'entre el ' + corto(r.listoMin) + ' y el ' + largo(r.listoMax);

    var titulo, texto, nota = '', primero = 'producto';
    if (r.estado === 'pasada') {
      titulo = 'Elegí una fecha a partir de mañana.';
      texto = 'Si lo necesitás para hoy, escribinos y vemos qué se puede hacer.';
      primero = 'whatsapp';
    } else if (r.estado === 'ok') {
      titulo = 'Sí, llegás bien.';
      texto = 'Pidiéndolo ' + cuando + ', ' + nombre + ' está ' + entrega.listo + ' ' + rango + '. Lo necesitás para el ' + largo(evento) + '.';
      if (r.ultimoPedido.getTime() > r.cero.dia.getTime()) {
        nota = 'Para llegar sin apuro, pedilo hasta el ' + largo(r.ultimoPedido) + ' antes de las ' + cfg.corte + ' h.';
      }
    } else if (r.estado === 'justo') {
      titulo = 'Llegás, pero justo.';
      texto = 'Con producción normal está ' + entrega.listo + ' ' + rango + ', y lo necesitás para el ' + largo(evento) + '. Pedilo ' + cuando + ' y avisanos la fecha.';
      nota = prod.urgente ? 'Para asegurarlo, marcá «Solicitar producción urgente (+10 %)» en el carrito.' : '';
      primero = 'whatsapp';
    } else if (r.estado === 'urgente') {
      titulo = 'Llegás con producción urgente.';
      texto = 'Con producción normal no llega para el ' + largo(evento) + '. Con producción urgente (+10 %), de ' + cfg.urgenteMin + ' a ' + cfg.urgenteMax + ' días hábiles, sí.';
      nota = 'Se pide en el carrito: marcá «Solicitar producción urgente».';
    } else if (r.estado === 'confirmar') {
      titulo = 'Puede llegar, pero hay que confirmarlo.';
      texto = 'Para el ' + largo(evento) + ' solo llegamos con producción urgente (+10 %), y depende del producto y de la carga del taller.';
      nota = 'Escribinos ahora y te confirmamos antes de que pagues.';
      primero = 'whatsapp';
    } else {
      titulo = 'Para esa fecha no llegamos con ' + (prod.nombre ? 'este producto' : 'la producción normal') + '.';
      texto = 'Escribinos igual: a veces hay otra opción que sí llega para el ' + largo(evento) + '.';
      primero = 'whatsapp';
    }

    var caja = crear('div', 'lf__veredicto lf__veredicto--' + r.estado);
    caja.appendChild(crear('p', 'lf__titular', titulo));
    caja.appendChild(crear('p', 'lf__texto', texto));
    if (nota) caja.appendChild(crear('p', 'lf__nota', nota));
    if (r.estado !== 'pasada' && r.estado !== 'no') {
      caja.appendChild(crear('p', 'lf__aclaracion', (r.cero.esHoy ? '' : 'Lo que entra después de las ' + cfg.corte + ' h o en fin de semana empieza el ' + corto(r.cero.dia) + '. ') +
        'Los días hábiles se cuentan desde que aprobás el diseño. ' +
        (entrega.dias ? 'Dejamos margen para el envío, que se cobra aparte.' : 'El envío se cobra aparte.')));
    }

    var botones = crear('div', 'lf__botones');
    var ver = crear('a', 'tm-btn tm-btn--full ' + (primero === 'producto' ? 'tm-btn--primary' : 'tm-btn--secondary'),
      prod.nombre ? 'Ver ' + prod.nombre : 'Ver los productos');
    ver.href = prod.url;
    var wa = crear('a', 'tm-btn tm-btn--full tm-btn--whatsapp', r.estado === 'justo' ? 'Avisar mi fecha por WhatsApp' : 'Consultar por WhatsApp');
    wa.href = enlaceWhatsApp(prod, evento, entrega);
    wa.target = '_blank';
    wa.rel = 'noopener';
    // Si ya está en la ficha de ese producto, «Ver» solo cierra el diálogo.
    if (prod.handle && location.pathname.indexOf('/products/' + prod.handle) >= 0) {
      ver.textContent = 'Seguir con ' + prod.nombre;
      ver.addEventListener('click', function (e) { e.preventDefault(); dlg.close(); });
    }
    if (primero === 'producto') { botones.appendChild(ver); botones.appendChild(wa); }
    else { botones.appendChild(wa); if (r.estado !== 'pasada') botones.appendChild(ver); }
    caja.appendChild(botones);
    resultado.appendChild(caja);
    // En el celular la respuesta puede quedar debajo del pliegue del diálogo: se la acerca.
    if (dlg.open && caja.scrollIntoView) caja.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function abrir(handle) {
    var a = ahora();
    campoFecha.min = iso(sumar(a.hoy, 1));
    if (handle) {
      for (var i = 0; i < campoProducto.options.length; i++) {
        if (campoProducto.options[i].value === handle) { campoProducto.selectedIndex = i; break; }
      }
    }
    pintar();
    if (!dlg.open) dlg.showModal();
  }

  document.addEventListener('click', function (e) {
    var disparador = e.target.closest ? e.target.closest('[data-lf-abrir]') : null;
    if (!disparador) return;
    e.preventDefault();
    abrir(disparador.getAttribute('data-lf-producto') || '');
  });

  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || (e.target.closest && e.target.closest('[data-lf-cerrar]'))) { dlg.close(); return; }
    var atajo = e.target.closest ? e.target.closest('[data-lf-atajo]') : null;
    if (!atajo) return;
    var a = ahora();
    var hastaSabado = (6 - a.hoy.getUTCDay() + 7) % 7 || 7;
    var destino = atajo.getAttribute('data-lf-atajo') === 'sabado' ? sumar(a.hoy, hastaSabado)
      : atajo.getAttribute('data-lf-atajo') === 'sabado2' ? sumar(a.hoy, hastaSabado + 7)
      : sumar(a.hoy, 15);
    campoFecha.value = iso(destino);
    pintar();
  });
  dlg.addEventListener('change', pintar);
  campoFecha.addEventListener('input', pintar);
})();
